const API_URL = import.meta.env.VITE_API_URL;

/**
 * Obtiene el token de autenticación desde localStorage
 */
const getAuthToken = () => {
  return localStorage.getItem('accessToken');
};

/**
 * Obtiene todas las configuraciones de membresía
 */
export const getMembershipConfigs = async () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const response = await fetch(`${API_URL}/membership-config`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Error al obtener configuraciones' }));
    throw new Error(error.message || 'Error al obtener configuraciones');
  }

  return response.json();
};

/**
 * Actualiza una configuración de membresía
 */
export const updateMembershipConfig = async (key, value, description) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const response = await fetch(`${API_URL}/membership-config/${key}`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ value, description }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Error al actualizar configuración' }));
    throw new Error(error.message || 'Error al actualizar configuración');
  }

  return response.json();
};

/**
 * Sube la ficha de presentación de CIDERE
 */
export const uploadPresentationFile = async (fileFormData) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const response = await fetch(`${API_URL}/membership-config/presentation-file`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: fileFormData,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Error al subir la ficha de presentación' }));
    throw new Error(error.message || 'Error al subir la ficha de presentación');
  }

  return response.json();
};

/**
 * Obtiene la URL de la ficha de presentación de CIDERE
 */
export const getPresentationFile = async () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const response = await fetch(`${API_URL}/membership-config/presentation-file`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Error al obtener la ficha de presentación' }));
    throw new Error(error.message || 'Error al obtener la ficha de presentación');
  }

  return response.json();
};

/**
 * Elimina la ficha de presentación de CIDERE
 */
export const deletePresentationFile = async () => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('No hay token de autenticación');
  }

  const response = await fetch(`${API_URL}/membership-config/presentation-file`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Error al eliminar la ficha de presentación' }));
    throw new Error(error.message || 'Error al eliminar la ficha de presentación');
  }

  return response.json();
};

